export const BeliefInFresh = {
  FRESH_IS_BEST: 4,
  FRESH_IS_GOOD: 3,
  NOT_SURE: 2,
  NO_TO_FRESH: 1,
} as const;

export type TBeliefInFreshValues = (typeof BeliefInFresh)[keyof typeof BeliefInFresh];

export const NumberOfTreats = {
  LOTS: "lots",
  SOME: "some",
  FEW: "few",
  NONE: "none",
} as const;

export type TNumberOfTreatsValues = (typeof NumberOfTreats)[keyof typeof NumberOfTreats];

export interface IFreshCustomerSUFAnswers {
  /** A value indicating the customer's belief in the benefits of fresh cat food. */
  beliefInFresh?: TBeliefInFreshValues | null;
  /** How many treats the customer gives to their cat. */
  numberOfTreats?: TNumberOfTreatsValues | null;
  /** Why the customer is trying KatKin.
   * Must be an array of strings.
   * No duplicates are allowed.
   * No empty arrays are allowed. */
  switchReasons?: string[] | null;
}
